export const STORAGE_KEYS = {
  LANG: "current-lang-page",
  I18N: "i18nextLng",
  THEME: "current-theme",
  SwicherLG: "themeToggle",
  SwicherIcon: "mode-icons",
};
